import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import { ScoutingAreaFilter } from "@/models/ScoutingArea";
import ScoutingMedium from "@/models/ScoutingMedium";
import { MediumType } from "@/models";

export const GET_SCOUTING_MEDIA = "get_scouting_media";
export const SAVE_SCOUTING_MEDIA = "save_scouting_media";

@Component
export default class ScoutingMediumMixin extends Vue {
  getScoutingMedia(analysisId: string) {
    const path = `${BASE_API_URL}/scoutings/analyses/${analysisId}/scouting_media?include=medium,medium.medium_type`;
    return this.$httpGet(path, GET_SCOUTING_MEDIA);
  }

  saveScoutingMedia(
    analysisId: string,
    mediumTypeId: string,
    sourceableId: string,
    sourceableType: string,
    scoutingMedia: ScoutingMedium[]
  ) {
    const path = `${BASE_API_URL}/scoutings/analyses/${analysisId}/scouting_media/massive`;
    return this.$httpPost(path, SAVE_SCOUTING_MEDIA, {
      mediumTypeId,
      sourceableId,
      sourceableType,
      media: scoutingMedia,
    });
  }
}
